<figure
  class="app-habitation-v2 image-{{ this.image }}"
  [style.min-height]="imageHeight"
  [appDynamicBackgroundImage]="getBackgroundImageSource()"
>
  <div class="wrapper header-image fade-in-top">
    <ng-content select="div.titre-page"></ng-content>
  </div>
</figure>
